import React, { Fragment } from "react";

import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Stack,
  Tag,
  Portal,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

import useTranslations from "../../../../hooks/useTranslations";

import { QuestionFragment } from '../../../../graphql/generated/definitions';

const QuestionDocuments: React.FC<{ question: QuestionFragment }> = ({
  question,
}) => {
  const t = useTranslations();
  const documents = question.documents;

  if (documents.length === 0) return null;

  return (
    <Box>
      <Menu id={`${question.id}.attached_files`}>
        <MenuButton
          as={Button}
          size="sm"
          variant="outline"
          rightIcon={<Icon as={ChevronDownIcon} />}
        >
          <Stack direction="row" spacing="2" alignItems="center">
            <Box as="span">
              {t("reports.shared.attachedFiles", { count: documents.length })}
            </Box>
            {/* Weird unalignement of the number inside of the Tag, adding padding as a quick fix */}
            <Tag size="sm" paddingTop=".1rem">
              {documents.length}
            </Tag>
          </Stack>
        </MenuButton>
        <Portal>
          <MenuList>
            {documents.map(({ id, filename, url }) => (
              <Fragment key={id}>
                <Box as="span" srOnly id={`${id}.download`}>
                  {t("reports.shared.attachedFilesAriaDescription")}
                </Box>
                <MenuItem
                  key={id}
                  as="a"
                  name={`${url}.download_link`}
                  target="_blank"
                  href={url}
                  aria-describedby={`${id}.download`}
                >
                  {filename}
                </MenuItem>
              </Fragment>
            ))}
          </MenuList>
        </Portal>
      </Menu>
    </Box>
  );
};
export default React.memo(QuestionDocuments);
